import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function FileGenericOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M0 0V22H15C17.7568 22 20 19.7568 20 17V0H0ZM18 17C18 18.6543 16.6543 20 15 20H2V2H18V17ZM15 8H5V6H15V8ZM11 13H5V11H11V13Z",
    fill: "currentColor"
  }));
}